import { API_ROOT, authHeaders } from './http.js';
import { getTranslationById, getTranslationByLang } from './translations.js';
const API_BASE = API_ROOT;

function getTelegramInitData() {
  const tg = window.Telegram?.WebApp;
  if (!tg) {
    return '';
  }
  if (!tg.initData && tg.ready) {
    const maxAttempts = 10;
    for (let i = 0; i < maxAttempts; i++) {
      if (tg.initData) break;
    }
  }
  const initData = tg.initData || '';
  return initData;
}

export const authAPI = {
  loginTelegram: async () => {
    try {
      const tg = window?.Telegram?.WebApp;
      if (!tg) return null;
 
      if (!initData) {
        try {
          const sp = new URLSearchParams(window.location.search);
          initData = sp.get('tgWebAppData') || '';
        } catch {}
      }
      if (!initData) return null;
      let hash = '';
      try {
        const params = new URLSearchParams(initData);
        hash = params.get('hash') || '';
      } catch {}
      if (!hash) return null;
      if (window.__tmaLoginOnce === initData) return null;
      const res = await fetch(`${API_BASE}/auth/telegram-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ initData, hash })
      });
      if (!res.ok) {
        let msg = `API error ${res.status}`;
        try { const j = await res.json(); if (j && (j.error || j.message)) msg = j.error || j.message; } catch {}
        throw new Error(msg);
      }
      const ct = res.headers.get('content-type') || '';
      if (ct.includes('application/json')) {
        const j = await res.json();
        try { window.__tmaLoginOnce = initData; } catch {}
        return j;
      }
      const txt = await res.text();
      try { window.__tmaLoginOnce = initData; } catch {}
      return txt;
    } catch (e) {
      return null;
    }
  }
};


async function apiRequest(endpoint, options = {}) {
  try {
    const headers = authHeaders({ 'Content-Type': 'application/json', ...(options.headers || {}) });
    const response = await fetch(`${API_BASE}${endpoint}`, { ...options, headers });
    if (!response.ok) {
      let msg = `API error ${response.status}`;
      try {
        const ct = response.headers.get('content-type') || '';
        if (ct.includes('application/json')) {
          const j = await response.json();
          if (j && typeof j === 'object') {
            if (j.error) msg = j.error;
            else if (j.message) msg = j.message;
            else if (Array.isArray(j.detail)) {
              const parts = j.detail.map((d) => {
                const loc = Array.isArray(d?.loc) ? d.loc.join('.') : '';
                const m = d?.msg ? String(d.msg) : '';
                return [loc, m].filter(Boolean).join(': ');
              }).filter(Boolean);
              if (parts.length) msg = parts.join('\n');
            }
          }
        } else {
          const text = await response.text();
          if (text) msg = text;
        }
      } catch {}
      throw new Error(msg);
    }
    const ct = response.headers.get('content-type') || '';
    if (ct.includes('application/json')) {
      return await response.json();
    }
    return await response.text();
  } catch (error) {
    if (error.message === 'Failed to fetch') {
      console.error(`Ошибка подключения к серверу`);
      throw new Error('Не удалось подключиться к серверу. Проверьте интернет-соединение.');
    }
    throw error;
  }
}


export const bookmarksAPI = {

  getAll: async ({ limit = 500, offset = 0 } = {}) => {
    const params = new URLSearchParams();
    if (limit != null) params.set('limit', String(limit));
    if (offset != null) params.set('offset', String(offset));
    const qs = params.toString();
    const raw = await apiRequest(`/bookmarks/${qs ? `?${qs}` : ''}`);
    if (Array.isArray(raw)) return raw;
    if (raw && Array.isArray(raw.items)) return raw.items;
    if (raw && Array.isArray(raw.bookmarks)) return raw.bookmarks;
    if (raw && Array.isArray(raw.data)) return raw.data;
    return [];
  },

  create: async (payload) => {
    return await apiRequest('/bookmarks/', {
      method: 'POST',
      body: JSON.stringify(payload || {}),
    });
  },

  deleteById: async (bookmarkId) => {
    return await apiRequest(`/bookmarks/id/${encodeURIComponent(String(bookmarkId))}`, {
      method: 'DELETE',
    });
  },
};


export const settingsAPI = {

  get: async () => {
    return await apiRequest('/settings');
  },

  update: async (settings) => {
    return await apiRequest('/settings', {
      method: 'PUT',
      body: JSON.stringify(settings),
    });
  },


  syncFromServer: async () => {
    try {
      const settings = await settingsAPI.get();

      if (settings.uiLanguage) {
        localStorage.setItem('ui_lang', settings.uiLanguage);
        window.dispatchEvent(new Event('ui_lang_changed'));
      }
      if (settings.reciter) {
        localStorage.setItem('reciter', settings.reciter);
      }
      if (settings.fontStyle) {
        localStorage.setItem('font_style', settings.fontStyle);
        localStorage.setItem('qcfStyle', settings.fontStyle);
      }
      if (settings.fontSize) {
        localStorage.setItem('font_size', settings.fontSize);
        localStorage.setItem('fontSize', String(settings.fontSize));
      }
      if (settings.theme) {
        localStorage.setItem('theme', settings.theme);
      }

      if (settings.translationLanguages) {
        const langs = typeof settings.translationLanguages === 'string'
          ? JSON.parse(settings.translationLanguages)
          : settings.translationLanguages;
        localStorage.setItem('translation_langs', JSON.stringify(langs));

        const selectedIds = (Array.isArray(langs) ? langs : [])
          .map((lang) => (typeof lang === 'string' ? getTranslationByLang(lang)?.id : null))
          .filter((id) => Number.isFinite(id));
        localStorage.setItem('selectedTranslations', JSON.stringify(selectedIds));
      }
      if (typeof settings.showTranslation === 'boolean') {
        localStorage.setItem('showTranslation', JSON.stringify(settings.showTranslation));
      }

      return settings;
    } catch (error) {
      console.error('Ошибка синхронизации настроек:', error);
      throw error;
    }
  },


  syncToServer: async () => {
    try {
      const uiLang = localStorage.getItem('ui_lang') || 'ru';
      const reciter = localStorage.getItem('selectedReciter') || localStorage.getItem('reciter') || 'Mishari_Rashid_al-Afasy';
      const fontStyle = localStorage.getItem('qcfStyle') || localStorage.getItem('font_style') || 'v1';
      const fontSizeRaw = localStorage.getItem('fontSize') || localStorage.getItem('font_size') || '3';
      const fontSizeParsed = parseInt(fontSizeRaw, 10);
      const fontSize = Number.isFinite(fontSizeParsed) ? Math.max(1, Math.min(10, fontSizeParsed)) : 3;
      const theme = localStorage.getItem('theme') || 'dark';
      let translations;
      try { translations = JSON.parse(localStorage.getItem('selectedTranslations') || '[]'); } catch { translations = []; }
      if (!Array.isArray(translations) || translations.length === 0) {
        try { translations = JSON.parse(localStorage.getItem('translation_langs') || '["ru"]'); } catch { translations = ['ru']; }
      }

      const translationLanguages = (Array.isArray(translations) ? translations : [])
        .map((v) => {
          if (typeof v === 'string') return v;
          if (Number.isFinite(v)) return getTranslationById(v)?.lang || null;
          return null;
        })
        .filter((v) => typeof v === 'string' && v.length > 0);
      const showTranslationRaw = localStorage.getItem('showTranslation');
      const showTranslation = showTranslationRaw != null ? JSON.parse(showTranslationRaw) : true;

      const settings = { uiLanguage: uiLang, reciter, fontStyle, fontSize, theme, translationLanguages, showTranslation };

      await settingsAPI.update(settings);
    } catch (error) {
      console.error('Ошибка сохранения настроек:', error);
      throw error;
    }
  },
};


export const userAPI = {

  get: async () => {
    return await apiRequest('/users/me');
  },
  existsByUsernames: async (usernames = []) => {
    const list = (Array.isArray(usernames) ? usernames : []).map(u => String(u || '').replace(/^@/, '')).filter(Boolean);
    if (list.length === 0) return [];
    return await apiRequest(`/users/exists?usernames=${encodeURIComponent(list.join(','))}`);
  },
};

export const statisticsAPI = {
  get: async () => {
    try {
      return await apiRequest('/statistics');
    } catch (e) {
      return null;
    }
  },
  updatePosition: async (surah, ayah, page = null) => {
    try {
      return await apiRequest('/statistics/position', {
        method: 'POST',
        body: JSON.stringify({ surah, ayah, page })
      });
    } catch (e) {
      return null;
    }
  },
  incrementProgress: async (count = 1) => {
    try {
      return await apiRequest('/statistics/progress', {
        method: 'POST',
        body: JSON.stringify({ count })
      });
    } catch (e) {
      return null;
    }
  }
};

export const khatmAPI = {
  listTasks: async () => {
    return await apiRequest('/khatm/tasks');
  },
  listGroups: async () => {
    return await apiRequest('/khatm/groups');
  },
  joinGroup: async (groupId = null, inviteToken = null) => {
    const params = new URLSearchParams();
    if (groupId) params.set('group_id', String(groupId));
    if (inviteToken) params.set('inviteToken', String(inviteToken));
    const qs = params.toString();
    const endpoint = qs ? (`/khatm/group/join?${qs}`) : '/khatm/group/join';
    return await apiRequest(endpoint, {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },
  getGroupProgress: async (id) => {
    return await apiRequest(`/khatm/group/${encodeURIComponent(id)}/progress`);
  },
  closeTask: async (id) => {
    return await apiRequest(`/khatm/task/${encodeURIComponent(id)}/close`, {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },
  closeGroup: async (id) => {
    return await apiRequest(`/khatm/group/${encodeURIComponent(id)}/close`, {
      method: 'POST',
      body: JSON.stringify({ status: 'completed' }),
    });
  },
  createTask: async (payload) => {
    return await apiRequest('/khatm/task', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
  updateTask: async (id, data) => {
    return await apiRequest(`/khatm/task/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },
  updateUnit: async (id, juz, data) => {
    return await apiRequest(`/khatm/task/${encodeURIComponent(id)}/progress/${encodeURIComponent(juz)}`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
  deleteTask: async (id) => {
    return await apiRequest(`/khatm/task/${encodeURIComponent(id)}`, {
      method: 'DELETE',
    });
  },
  listInvites: async () => {
    return await apiRequest('/khatm/invites');
  },
  acceptInvite: async (participantId) => {
    return await apiRequest(`/khatm/invite/${encodeURIComponent(participantId)}/accept`, {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },
  declineInvite: async (participantId) => {
    return await apiRequest(`/khatm/invite/${encodeURIComponent(participantId)}/decline`, {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },
  updateGroupUnit: async (id, juz, data) => {
    return await apiRequest(`/khatm/group/${encodeURIComponent(id)}/progress/${encodeURIComponent(juz)}`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
  deleteGroup: async (id) => {
    return await apiRequest(`/khatm/group/${encodeURIComponent(id)}`, {
      method: 'DELETE',
    });
  },
  updateGroupStatus: async (id, status) => {
    return await apiRequest(`/khatm/group/${encodeURIComponent(id)}/status`, {
      method: 'POST',
      body: JSON.stringify({ status }),
    });
  },
  leaveGroup: async (id) => {
    return await apiRequest(`/khatm/group/${encodeURIComponent(id)}/leave`, {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },
};
